import React from 'react'
import styled from 'styled-components/macro'
import ReactGA from 'react-ga'
import { getGelTokens } from '@tal-gel/theming'

import Label from '../Typography/Label'
import icon from './link-arrow.svg'

const Component = styled(ReactGA.OutboundLink)`
  display: inline-flex;
  align-items: center;
  position: relative;
  text-decoration: none;

  &:after {
    content: '';
    position: absolute;
    height: 2px;
    width: 100%;
    background: ${() => getGelTokens().brand.brandColorPrimary1 };
    bottom: -2px;
    left: 0;
  }

  & > p {
    color: ${() => getGelTokens().brand.brandColorPrimary1 };
  }
`

const Icon = styled.img`
  margin-left: 8px;
`

const Link = ({ url, title }) => (
  <Component
    href={url}
    target='_blank'
    rel='noopener noreferrer'
    eventLabel={url}
    to={url}
  >
    <Label small secondary bold>
      {title}
    </Label>{' '}
    <Icon src={icon} alt={title} />
  </Component>
)

export default Link
